import { z } from "zod";

const TRANSLATION_PATH = "page.topmedSchedule.newSchedule.errors.";

const specialtySchema = z.object(
  {
    code: z.number(),
    description: z.string(),
    nextAvailableDate: z.string().nullable(),
  },
  { invalid_type_error: TRANSLATION_PATH + "specialty" }
);

const scheduleSchema = z.object({
  hash: z.string(),
  date: z.string(),
});

const professionalSchema = z.object({
  name: z.string(),
  specialty: z.string(),
  acronym: z.string(),
  professionalCouncilRegister: z.string(),
  professionalCouncil: z.string(),
  imageFullPath: z.string(),
  schedules: z.array(scheduleSchema),
});

export const confirmTopMedScheduleSchema = z
  .object({
    specialty: specialtySchema,
    professional: professionalSchema.nullish(),
    date: z.date({ required_error: TRANSLATION_PATH + "date" }),
    schedule: scheduleSchema.nullish(),
    symptoms: z
      .string()
      .trim()
      .min(1, TRANSLATION_PATH + "symptoms"),
  })
  .superRefine((val, ctx) => {
    if (!val.schedule) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: TRANSLATION_PATH + "time",
        path: ["schedule"],
      });
    }
  });

export type TConfirmTopMedScheduleForm = z.infer<
  typeof confirmTopMedScheduleSchema
>;
